import React, { useState, useEffect } from "react";
import { Button } from "antd";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { MdOutlineDownload } from "react-icons/md";
import pdfImg from "../../assets/images/icon/pdf.png";
import "../../Styles/survey.css";

import { MdKeyboardArrowRight } from "react-icons/md";
import { useLocation, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ReportDownload = ({
  selectedReport = {},
  setSelectedReport = () => {}
}) => {
  const { t } = useTranslation();
  const axiosInstance = useAxiosInstance();
  const [fileUrl, setFileUrl] = useState("");
  const location = useLocation();
  const state = location?.state || {};

  useEffect(() => {
    if (state) {
      handleDownload(state);
    }
  }, [state]);
  const handleBack = () => {
    window.history.back();
  };

  const handleDownload = (record) => {
    if (record.status === "close") {
      axiosInstance
        .get(`api/reports/client/viewRequestedReport/${record._id}`, {
          headers: {
            subscription: "advanced"
          }
        })
        .then((res) => {
          const publicUrl = res.data.data.publicUrl;
          setFileUrl(publicUrl);
        });
    } else {
      axiosInstance
        .get(`api/reports/${record._id}`, {
          headers: {
            subscription: "advanced"
          }
        })
        .then((res) => {
          const publicUrl = res.data.data.resourceLocation[0].publicUrl;
          setFileUrl(publicUrl);
        });
    }
  };

  const handleDownloadButtonClick = () => {
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    link.setAttribute("target", "_blank");
    link.click();
  };

  const getFileType = (url) => {
    return url?.split(".").pop()?.toLowerCase();
  };

  return (
    <div className='logout-wrapper'>
      <div className='userinfo-breadcrumbs'>
        {" "}
        <div className='flex'>
          <NavLink to='/reports/report-database'>
            <h1>
              {t("Report")}
              <MdKeyboardArrowRight className='inline-block' />
            </h1>
          </NavLink>
          {/* <NavLink to="/assetsManagement/user/userInfo"> */}
          <h1 onClick={handleBack}>
            {t("Report Details")}{" "}
            <MdKeyboardArrowRight className='inline-block' />
          </h1>
          {/* </NavLink> */}
        </div>
      </div>
      <div className='flex justify-center'>
        <div className='client-details w-[90vw]'>
          <div className='tab-heading flex items-end justify-between'>
            <h4 className='mb-2'>{t("Report Details")}</h4>
            <div className='download-Btn'>
              <Button
                type='button'
                className='download-button'
                onClick={handleDownloadButtonClick}
              >
                <MdOutlineDownload className='mt-1' />
                <span className='pl-1'>Download</span>
              </Button>
            </div>
          </div>
          <div className='flex flex-col mt-4'>
            <div className='firstname-field'>
              <p>
                <span>{t("REPORT NAME")}</span>
                <span>{state?.reportName}</span>
              </p>
            </div>

            <div className='firstname-field'>
              <p>
                <span>{t("DESCRIPTION")}</span>
                <span>{state?.description}</span>
              </p>
            </div>

            <div className='firstname-field'>
              <p>
                <span>{t("UPLOAD DATE")}</span>
                <span>{new Date(state?.updatedAt).toLocaleDateString()}</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* {fileUrl && (
        <div>
          <embed
            src={fileUrl || pdfImg}
            style={{
              width: "100%",
              height: "800px",
              border: "none",
              padding: "20px",
              margin: "10px"
            }}
          />
        </div>
      )} */}

      {fileUrl && (
        <div>
          {["xlsx", "xls"].includes(getFileType(fileUrl)) ? (
            <>
              <iframe
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                  fileUrl
                )}`}
                width="100%"
                height="800px"
                style={{ border: "none", padding: "20px" }}
                title="Excel Preview"
              />

              <div style={{ textAlign: "center", marginTop: "10px" }}>
                <a href={fileUrl} target="_blank" rel="noreferrer">
                  Open Excel File
                </a>
              </div>
            </>
          ) : (
            <embed
              src={fileUrl}
              style={{
                width: "100%",
                height: "800px",
                border: "none",
                padding: "20px",
                margin: "10px"
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};
export default ReportDownload;
